module.exports = __webpack_public_path__ + "static/images/callout_2.52b7404fd7f39182af76359e384ec087.jpg";